import { ClipboardCheck, Search, FileSignature, Banknote } from "lucide-react";

const steps = [
  {
    n: "01",
    title: "Request an offer",
    desc: "Enter your VIN or plate, or type in the year, make, model and mileage. Tell us about the condition. This is a request, not a purchase offer.",
    Icon: ClipboardCheck,
  },
  {
    n: "02",
    title: "We review and inspect",
    desc: "We look over your details, call or text you with questions, and arrange an in-person inspection of the vehicle.",
    Icon: Search,
  },
  {
    n: "03",
    title: "You get a written offer",
    desc: "After the inspection we give you an actual offer in writing. Take your time. You are never obligated to accept.",
    Icon: FileSignature,
  },
  {
    n: "04",
    title: "Paperwork and payment",
    desc: "If you accept, we complete the title transfer together and pay you the same day, using the payment method agreed in writing.",
    Icon: Banknote,
  },
];

export default function HowItWorksSection() {
  return (
    <section data-testid="how-it-works-section" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-blue">How it works</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight mt-2">
            Four honest steps. No surprises.
          </h2>
          <p className="text-base sm:text-lg text-slate-600 mt-4 leading-relaxed">
            We are a small, veteran-owned business. You deal directly with the owner from the first call to the handshake.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mt-12">
          {steps.map(({ n, title, desc, Icon }, i) => (
            <div
              key={n}
              data-testid={`how-step-${i}`}
              className="relative bg-white rounded-2xl border border-slate-100 p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex items-start justify-between mb-6">
                <span className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-blue-50 text-brand-blue">
                  <Icon className="w-7 h-7" />
                </span>
                <span className="font-display text-4xl font-extrabold text-slate-200 leading-none">{n}</span>
              </div>
              <h3 className="font-display text-xl font-bold text-slate-900 mb-2">{title}</h3>
              <p className="text-slate-600 leading-relaxed text-[15px]">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
